'use strict';

/* eslint no-continue: 0 */
module.exports = function ( list, language, file ) {
    var selected = null,
        index, languageCode0, languageCode1;

    if ( list && list.length !== 0 ) {
        if ( list.length === 1 ) {
            selected = list[0];
        } else {
            if ( language.length ) {
                if ( language.length > 1 ) {
                    languageCode1 = language[1];
                }
                languageCode0 = language[0];
                if ( languageCode0 === '' && (!languageCode1 || languageCode1 === '') ) {
                    if ( file.languages.length ) {
                        languageCode0 = file.languages[0];
                    }
                }
            } else if ( file.languages.length ) {
                languageCode0 = file.languages[0];
            }

            for ( index = 0; index < list.length; index++ ) {
                if ( list[index].value ) {
                    if (
                        list[index].value.languages.indexOf(languageCode0) !== -1
                        || (languageCode1 && list[index].value.languages.indexOf(languageCode1) !== -1)
                    ) {
                        if ( list[index].value.quality.width === file.quality.width ) {
                            selected = list[index];
                            break;
                        }

                        if ( list[index].value.quality.width > file.quality.width ) {
                            selected = {
                                value: list[index].value,
                                index: index
                            };
                            continue;
                        }

                        selected = {
                            value: list[index].value,
                            index: index
                        };
                        break;
                    }
                }
            }
        }
    }

    return selected;
};
